/* eslint-disable prefer-arrow-callback,no-var */
(function loadPlayer(tv2Player) {
  var playerBasePath =
    'https://shared.tv2.dk/sites/all/themes/t2/js/tv2player/';

  // Send event, with polyfill for IE11
  var sendEvent = function _customEvent(event) {
    if (typeof window.CustomEvent === 'function') {
      // CustomEvent is supported, fire it
      return document.dispatchEvent(new window.CustomEvent(event));
    } else {
      // Polyfill custom event for IE11
      function CustomEvent(event, params) {
        params = params || {
          bubbles: false,
          cancelable: false,
          detail: undefined,
        };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(
          event,
          params.bubbles,
          params.cancelable,
          params.detail,
        );
        return evt;
      }
      CustomEvent.prototype = window.Event.prototype;
      return document.dispatchEvent(new CustomEvent(event));
    }
  };

  // if tv2PLayer is not available, load the player script
  if (!tv2Player) {
    // Set player base path
    window.tv2 = window.tv2 || {};
    window.tv2.playerBasePath = playerBasePath;

    // and inject the player script
    var scriptTag = document.createElement('script'); // eslint-disable-line vars-on-top
    scriptTag.setAttribute('src', playerBasePath + 'main.tv2-player.js');
    document.head.appendChild(scriptTag);
    scriptTag.addEventListener('load', function onload() {
      // Script was loaded, send event
      sendEvent('tv2player.ready');
    });
  }
})((window.tv2player = window.tv2player || false));
